/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import PageHeader from "../../../components/PageHeader";
import useForm from "../../../hooks/useForm";
import { getTaxSingoScheduled, getTaxSingoTaxPayerSingoList } from "../../../apis/tax-portal/tax-singo/tax-singo";
import { getTaxSingoStatus, isCorporateRegistration, taxSingoFileConverter } from "../../../utils/taxPortal/tax-singo";
import { ControlTable } from "../../../components/Table";
import Filters from "../../../components/Filters";
import DataComponent from "../../../components/DataComponent";
import { TAX_SINGO_ELECTRONIC_DATA_COLUMNS, TAX_SINGO_STATUS_LIST, TAX_SINGO_TYPE_LIST, TAX_SINGO_WETAX_ELECTRONIC_DATA_COLUMNS } from "../../../constants/TaxPortal/TAX_SINGO";
import { getParams } from "../../../utils/params";
import TaxSingoItem from "../../../components/TaxPortal/TaxSingo/TaxSingoItem";
import TaxSingoItemMemo from "../../../components/TaxPortal/TaxSingo/TaxSingoItem/TaxSingoItemMemo";
import { custodianPreview } from "../../../utils/custodian";
import systemAlert from "../../../utils/systemAlert";
import TaxSingoScrapingModal from "./taxSingoScrapingModal";
import TaxSingoItemDownload from "../../../components/TaxPortal/TaxSingo/TaxSingoItem/TaxSingoItemDownload";
import { getMyFinanceAccountSub } from "../../../apis/tax-portal/financeAccountSub";
import { transformComNum } from "../../../utils/validator/comNum";
import { getTaxAccountantFinancesAccounts } from "../../../apis/tax-accountant-finance/auth";
import { get } from "lodash";
// import { isEmpty } from "../../../utils/lodashExtend";
import TaxSingoWetaxScrapingModal from "./taxSingoWetaxScrapingModal";
import { transformComma } from "../../../utils/validator/comma";
import { isEmpty } from "../../../utils/lodashExtend";
import Button from "../../../components/Button";
import ToolTip from "../../../components/ToolTip/ToolTip";
import ManagerCounseling from "../../../components/Counseling/ManagerCounseling";


const TaxSingoScheduledList = ({ scheduledIdx }) => {

  const [scheduled, setScheduled] = useState(null);
  const [taxSingoType, setTaxSingoType] = useState(null);

  const [fields, setFields] = useState([]);

  const [counselingData, setCounselingData] = useState(null);
  const [open, setOpen] = useState(false);

  const {
    form,
    setSubmit,
    handleOnChange,
    filterSubmit,
    list,
    setList,
    isLoading,
    setIsLoading,
    total,
    setTotal,
    page,
    setPage,
    limit,
    setLimit,
    reSubmit,

    selectedList,
    setSelectedList,
  } = useForm({
    limit: 10,
    offset: 0,
    search: {},
  });

  useEffect(() => {
    setSubmit(submit);
    if (scheduledIdx) {
      submit(form);
      setScheduledAction();
    }
  }, [scheduledIdx]);


  const openTaxperDetail = (data) => {
    if (!data?.taxpayer) return systemAlert('수임처 정보가 없습니다.')
    custodianPreview(data.taxpayer.idx);
  };
  const electronicDataView = (data) => {
    systemAlert(<>{TAX_SINGO_ELECTRONIC_DATA_COLUMNS.map(({ key, label }) => <>
      {label} : {data[key]}<br />
    </>)}</>, { size: 'md' })
  }
  const wetaxElectronicDataView = (data) => {
    systemAlert(<>{TAX_SINGO_WETAX_ELECTRONIC_DATA_COLUMNS.map(({ key, label }) => <>
      {label} : {data[key]}<br />
    </>)}</>, { size: 'md' })
  }

  const taxSingoFileCounselingConverter = (props) => {
    const { linkSource, fileName } = taxSingoFileConverter(props)
    return `<p><a download="${fileName}" href="${linkSource}">${fileName.split('.pdf')[0]
      } 다운로드</a></p>`
  }


  const convertCounselingData = (data) => {

    let content = ''
    let title = `${data.taxpayer.companyName} - ${scheduled.name}`
    if (!!data?.electronicData?.pdfHex1) {
      content += taxSingoFileCounselingConverter({
        data: data?.electronicData?.pdfHex1,
        scheduled,
        taxpayer: data.taxpayer,
        name: '접수증'
      })
      title += ', 접수증'
    }
    
    if (!!data?.electronicData?.listPdfPath2[0]?.pdfHex2) {
      const array = data?.electronicData?.listPdfPath2
      for (let index = 0; index < array.length; index++) {
        const pdf = array[index]?.pdfHex2;
        // taxpayerSingo.electronicData.listPdfPath2[0].pdfHex2
        if (pdf) {
          content += taxSingoFileCounselingConverter({
            data: pdf,
            scheduled,
            taxpayer: data.taxpayer,
            name: `납부서${index + 1}`
          })
        }
      }
      title += ', 납부서'
    }

    if (!!data?.wetaxElectronicData?.pdfHex) {
      content += taxSingoFileCounselingConverter({
        data: data?.wetaxElectronicData?.pdfHex,
        scheduled,
        taxpayer: data.taxpayer,
        name: '지방세납부서'
      })
      title += ', 지방세납부서'
    }

    const counseling = {
      category: 8,
      fileIdxes: [],
      title,
      content,
      companyIdx: data.taxpayer.companyToTaxpayer?.companyIdx,
      careCompany: { ...data.taxpayer.companyToTaxpayer?.company },
    };

    setCounselingData(counseling);
  };

  useEffect(() => {

    if (scheduled) {
      const _taxSingoType = TAX_SINGO_TYPE_LIST.find(t => t.value === scheduled.singoType)
      setTaxSingoType(_taxSingoType)
      setFields([
        {
          title: "상태",
          key: "status",
          width: 88,
          onValue: (_data, _field, datas) => {

            const { color, label } = getTaxSingoStatus(datas.status);
            return (
              <DataComponent
                field={{
                  type: "badge",
                  color,
                  label,
                }}
              />
            );
          },
        },
        {
          title: "수임처",
          width: 150,
          style: { minWidth: '100px' },
          tooltip: {
            position: 'bottom',
            tooltiptext: "클릭시 수임처의 상세정보를 볼 수 있습니다."
          },
          key: "taxpayer.companyName",
          onValue: (data, f, datas) => {
            return <div className="cursor-pointer" onClick={() => openTaxperDetail(datas)}>
              {data}{datas?.taxpayer?.bsno ? <><br />
                {transformComNum(datas.taxpayer.bsno)}</> : <></>}
            </div>
          }
        },
        {
          title: "구분",
          width: 50,
          style: { minWidth: '50px' },
          key: "taxpayer.bsno",
          onValue: (data, f, datas) => {
            return <>{isCorporateRegistration(data) ? '법인' : '개인'}</>
          }
        },
        {
          title: "대표자",
          width: 50,
          style: { minWidth: '50px' },
          key: "taxpayer.ceoName",
          onValue: (data, f, datas) => {
            return <div className="cursor-pointer">
              {data}{datas?.taxpayer?.resno ? <><br />
                {datas.taxpayer.resno.substr(0, 6)}</> : <></>}
            </div>
          }
        },
        {
          title: "메모",
          key: "memo",
          width: 88,
          onValue: (_d, _f, _data) => {
            return <TaxSingoItemMemo
              key={'memo'}
              taxpayerSingo={_data}
              reSubmit={reSubmit}
            />
          }
        },
        ...(scheduled.data.map((d) => {
          return {
            width: 120,
            className: (data) => {
              const target = data.data.find((_d) => _d.idx === d.idx)
              if (!target || !target.status || target.status === 'pending') return `tax-singo-item-td`
              const statusObj = getTaxSingoStatus(target.status)
              return `tax-singo-item-td bg-soft-${statusObj.color}`
            },
            title: d.name,
            tooltip: d.description ? {
              position: 'bottom',
              tooltiptext: d.description,
              boxStyle: {
                width: 'auto',
                minWidth: '100px',
                padding: '5px 10px'
              }
            } : null,
            onValue: (_d, _f, _data) => {

              return <TaxSingoItem
                scheduled={scheduled}
                taxpayerSingo={_data}
                dataIdx={d.idx}
                reSubmit={reSubmit}
              />
            }
          }
        })),
        ...(!!_taxSingoType ? [
          {
            width: 120,
            title: "접수증",
            key: "electronicData.pdfHex1",
            tooltip: {
              position: 'bottom',
              tooltiptext: "신고내역 스크래핑을 통해 가져올 수 있습니다.",
              boxStyle: {
                width: 'auto',
                minWidth: '100px',
                padding: '5px 10px'
              }
            },
            onValue: (_d, _f, _data) => {
              return <TaxSingoItemDownload
                scheduled={scheduled}
                taxpayerSingo={_data}
                taxpayer={_data.taxpayer}
                data={_d}
                name={'접수증'}
              />
            }
          },
          {
            width: 120,
            title: "납부서",
            key: "electronicData.listPdfPath2[0].pdfHex2",
            tooltip: {
              position: 'bottom',
              tooltiptext: "신고내역 스크래핑을 통해 가져올 수 있습니다.",
              boxStyle: {
                width: 'auto',
                minWidth: '100px',
                padding: '5px 10px'
              }
            },
            onValue: (_d, _f, _data) => {
              return <TaxSingoItemDownload
                scheduled={scheduled}
                taxpayerSingo={_data}
                taxpayer={_data.taxpayer}
                data={_d}
                name={'납부서'}
              />
            }
          },

        ] : []),
        ...(!!_taxSingoType?.wetaxElectronicData ? [
          {
            width: 120,
            title: "지방세 납부서",
            key: "wetaxElectronicData.pdfHex",
            tooltip: {
              position: 'bottom',
              tooltiptext: "위택스 스크래핑을 통해 가져올 수 있습니다.",
              boxStyle: {
                width: 'auto',
                minWidth: '100px',
                padding: '5px 10px'
              }
            },
            onValue: (_d, _f, _data) => {
              return <TaxSingoItemDownload
                scheduled={scheduled}
                taxpayerSingo={_data}
                taxpayer={_data.taxpayer}
                data={_d}
                name={'지방세_납부서'}
              />
            }
          },
          {
            title: "지방세 납부세액 (위택스 신고내역 확인)",
            width: 100,
            key: "wetaxElectronicData",
            tooltip: {
              position: 'left',
              tooltiptext: "클릭시 신고내역 상세화면을 볼 수 있습니다."
            },
            onValue: (_d, _f, _data) => <>{_d ? <a style={{ textDecoration: 'underline' }} onClick={() => wetaxElectronicDataView(_data.wetaxElectronicData)}>{transformComma(_data?.wetaxElectronicData?.taxAmt)}원</a> : '-'}</>
          },

        ] : []),
        ...(!!_taxSingoType ? [

          {
            title: "전송",
            key: "state",
            onValue: (_value, _field, data) => {
              const isPossible = !!data?.electronicData?.pdfHex1 || !!data?.electronicData?.listPdfPath2[0]?.pdfHex2 || !!data?.wetaxElectronicData?.pdfHex
              return isPossible ? (
                isEmpty(data?.taxpayer?.companyToTaxpayer?.company) ? <>사용불가<ToolTip tooltiptext="수임처관리에서 wecake Biz와 연동하신 뒤에 이용하실 수 있습니다." />
                </> : <Button
                  size="x-sm"
                  color="gray-line"
                  onClick={() => {
                    convertCounselingData(data);
                    setOpen(true);
                  }}

                >
                  전송하기
                </Button>
              ) : <>-</>;
            }
          },
          {
            title: "전자신고자ID (신고내역 확인)",
            width: 100,
            key: "electronicReporterId",

            tooltip: {
              position: 'left',
              tooltiptext: "전자신고한 ID를 표시합니다. \n 클릭시 신고내역 상세화면을 볼 수 있습니다."
            },
            onValue: (_d, _f, _data) => <>{_d ? <a style={{ textDecoration: 'underline' }} onClick={() => electronicDataView(_data.electronicData)}>{_d}</a> : '-'}</>
          },
        ] : []),

      ])
    }
  }, [scheduled])


  const setScheduledAction = () => {
    setIsLoading(true);
    getTaxSingoScheduled(scheduledIdx)
      .then((res) => {
        setScheduled(res.data);
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const submit = (form) => {
    getTaxSingoTaxPayerSingoList(getParams({ scheduledIdx, ...form }))
      .then((res) => {
        setList(res.data.data);
        setTotal(res.data.total);
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const [filters] = useState([
    {
      title: "수임처명",
      key: "search.companyName",
    },
    {
      title: "상태",
      key: "search.status",
      type: "select",
      value: "all",
      options: {
        list: [{ label: "전체", value: "all" }, ...TAX_SINGO_STATUS_LIST],
      },
    },
  ]);


  const [headerButtons, setHeaderButtons] = useState([])
  const [myFinanceAccountSub, setMyFinanceAccountSub] = useState(null)
  const [myFinanceAccountWetax, setMyFinanceAccountWetax] = useState(null)

  const [isOpen, setIsOpen] = useState(false)
  const [isOpenWetax, setIsOpenWetax] = useState(false)
  useEffect(() => {
    if (scheduled?.singoType) {
      getMyFinanceAccountSub()
        .then((res) => {
          setMyFinanceAccountSub(res.data || null)
        })
      getTaxAccountantFinancesAccounts('tax-accountant-wetax')
        .then((res) => {
          const a = get(res, 'data.accounts[0]', null)
          setMyFinanceAccountWetax(a)
        })

    }
  }, [scheduled])

  useEffect(() => {
    if (taxSingoType) {
      setHeaderButtons(
        [

          {
            label: "홈택스 스크래핑",
            action: () => {
              if (!myFinanceAccountSub) {
                systemAlert('"Wecake T 관리 - 홈택스 설정 - 부서사용자" 에서 매칭된 홈택스 부서사용자가 필요합니다.')
              } else {
                setIsOpen(true)
              }
            },
          },

          ...(!!taxSingoType.wetaxElectronicData ? [
            {
              label: "위택스 스크래핑",
              action: () => {
                if (!myFinanceAccountWetax) {
                  systemAlert('"Wecake T 관리 - 위택스 설정" 에 정보 등록이 필요합니다.')
                } else {
                  setIsOpenWetax(true)
                }
              },
            },
          ] : []),
        ])
    } else {
      setHeaderButtons([])

    }
  }, [myFinanceAccountSub, myFinanceAccountWetax])


  const tableButtons = [
    // {
    //   // isHide: !(targetPermission && targetPermission.level > 1),
    //   label: "삭제",
    //   color: "red",
    //   disabled: isEmpty(selectedList),
    //   action: () => {
    //     // getTaxAccountantHometaxTaxpayers();
    //   },
    // },
    // {
    //   // isHide: !(targetPermission && targetPermission.level > 1),
    //   label: "추가",
    //   action: () => {
    //     // setDetailOpen(true);
    //   },
    // },
  ];


  return (
    <div className="tax-singo-wrap">



      <div className="tax-singo-table">
        <PageHeader
          title={scheduled?.name}
          buttons={headerButtons}
        />
        <div className="tax-singo-description-wrap">
          <div className="tax-singo-description-text-wrap">
            {/* <Icon src={successChecked} /> */}
            <span className="tax-singo-description-text" style={{ whiteSpace: 'pre-line' }}>
              {scheduled ? `${scheduled.description}` : ""}
            </span>
          </div>
        </div>
        <Filters
          isLoading={isLoading}
          filters={filters}
          submit={filterSubmit}
          form={form}
          onChange={handleOnChange}
        />
        <ControlTable
          isControl
          selectedList={selectedList}
          setSelected={setSelectedList}
          buttons={tableButtons}
          isLoading={isLoading}
          fields={fields}
          list={list}
          total={total}
          page={page}
          setPage={setPage}
          limit={limit}
          setLimit={setLimit}
        />
      </div>
      {scheduled?.singoType &&
        <TaxSingoScrapingModal
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          scheduled={scheduled}
          singoType={scheduled.singoType}
          reload={reSubmit}
        />
      }
      {taxSingoType?.wetaxElectronicData &&
        <TaxSingoWetaxScrapingModal
          isOpen={isOpenWetax}
          setIsOpen={setIsOpenWetax}
          scheduled={scheduled}
          singoType={scheduled.singoType}
          reload={reSubmit}
        />
      }

      <ManagerCounseling
        counselingType={"tax"}
        counseling={counselingData}
        setCounseling={setCounselingData}
        open={open}
        setOpen={setOpen}
        submit={() => { setCounselingData(null); }}
        orgMode={"create"}
      />
    </div >
  );
};

export default TaxSingoScheduledList;
